import React, { useState, useEffect } from "react";

import api from "../../../api";
import Banner from "./include/Banner"; // Assuming the updated Banner component from the previous example is used

// Define the API URL
const API_URL = `${process.env.REACT_APP_API_URL}/api/research/phd`; // Use the same endpoint if 'phd' data is nested within it, or adjust if it's a separate endpoint.
// Assuming the 'phd' data is part of the same /api/research response, we'll fetch all data and use the 'phd' key.

const ResearchPhdProgram = () => {
    const [phdData, setPhdData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    // Fetch data from API
    useEffect(() => {
        const fetchPhdData = async () => {
            try {
                // Fetch the data from the API
                const response = await api.get(API_URL);
                // Assuming the API response has a key 'phd' containing the required data
                setPhdData(response.data.phd); 
            } catch (err) {
                console.error("Error fetching PhD data:", err);
                setError("Failed to load PhD program data.");
            } finally {
                setLoading(false);
            }
        };

        fetchPhdData();
    }, []);

    if (loading) {
        return <div className="container mt-5 text-center">Loading Ph.D Program Details...</div>;
    }

    if (error || !phdData) {
        return <div className="container mt-5 text-center text-danger">{error || "Ph.D program data not available."}</div>;
    }
    
    const bannerContent = phdData.content;

    /*
    * The 'content' field from the API is a single HTML-like string with simple div/text structure.
    * The original component uses hardcoded structure (p, ul, li) with specific styling and links.
    * We will attempt to render the API content using dangerouslySetInnerHTML.
    * NOTE: This will remove the individual AOS animations and list formatting 
    * unless the HTML in the API response is modified to include those structures.
    */
    const createMarkup = (htmlContent) => {
        // Simple string replacement to re-add links and specific bolding, as the API stripped them.
        // This is a common but fragile necessity when an API returns unformatted content.
        let contentWithLinks = htmlContent;
        contentWithLinks = contentWithLinks.replace(
            "(For more details visit: https://care.edu.in/research/)",
            '(For more details visit: <a href="https://care.edu.in/research/" target="_blank" rel="noopener noreferrer">https://care.edu.in/research/</a>)'
        );
        contentWithLinks = contentWithLinks.replace(
            "Click here for\r\n",
            'Click here for <a href="http://careadmission.care.edu.in/phd_courses.php" target="_blank" rel="noopener noreferrer">CARE Admission Page</a><br/>'
        );
        contentWithLinks = contentWithLinks.replace(
            "Click here to Download Ph.D Regulations",
            '<a href="https://care.edu.in/wp-content/uploads/2020/09/UGC_Regulations2019.pdf" target="_blank" rel="noopener noreferrer">Click here to Download Ph.D Regulations</a>'
        );
        
        return { __html: contentWithLinks };
    };

    return (
        <>
        {/* Pass fetched banner data to the Banner component */}
        <Banner 
            bannerImages={bannerContent.images}
            heading={bannerContent.heading}
        />
        
        <section>
            <div className="container ">
                <div className="row mb-5">
                    <div className="col-md-12">
                        <div className="res-content"><div className="sec-title text-center"><h2> {bannerContent.heading}</h2></div>
                        
                            
                            {/* Render the main content from the API */}
                            <div 
                           
                                // Use the content from the API
                                dangerouslySetInnerHTML={createMarkup(bannerContent.content)}
                            />

                            {/* Note on structure: 
                            The original list structure with staggered AOS (li with data-aos-delay)
                            and internal span styling is lost when rendering the flat HTML string. 
                            To restore that, the API would need to return structured JSON data 
                            for the thrust areas and program details, or the content string must 
                            be parsed and re-wrapped manually, which is complex and often brittle.
                            The current approach ensures all text content is visible and retains 
                            the main 'fade-up' AOS effect on the whole block.
                            */}

                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default ResearchPhdProgram;





